import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import ModalContent from "../pages/modal";
import { ModalDialog, Modal } from "react-bootstrap";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import GrapesmodalContent from "../pages/grapesmodal";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
// import "grapesjs/dist/css/grapes.min.css";
import { saveTitleandurl } from "../../actions";

class FooterMenuList extends Component {
  constructor(props) {
    super(props);
    // this.state = { isOpen: false };
    // this.state = { isOpen: false, id: 0 };
    this.state = { isOpen: false, id: 0,section:'' };
  }

  // openModals = (pageid) => this.setState({ isOpen: true, id: pageid });
  // closeModals = () => this.setState({ isOpen: false });

  openModals = (section) => {

    // this.setState({ isOpen: true, id: pageid });
    // this.setState({ isOpen: true, section: section });
    this.setState({ isOpen: true, section: section, id: this.props.headerFooter.resource[0].id });
    // this.setState({ isOpen: true, section: section, id: this.props.values.id  });
    // let section = response.result.resource[0].section;
  };
  closeModals = () => this.setState({ isOpen: false });

  viewfooterSite = (e) => {
    let siteURL ="http://staging.teks.co.in/udayan/preview/footer/index.php";
      // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
    window.open(siteURL, "_blank");
  };

  render() {
    return (
      <ul className="footer-menu">
        {/* <li>Courses</li>
        <li>Why Us</li>
        <li>About Us</li>
        <li>Pricing</li>
        <li>Contact Us</li> */}
        <li style={{ marginTop: -11 }}>
          <button
            className="btn-custom-blue btn"
            // onClick={this.openModals('footer')}
            onClick={() => this.openModals('footer')}
            // onClick={this.openModals}
            style={{ marginRight: 5, border: "none" }}
          >
            Edit
          </button>
          {this.state.isOpen ? (
            <GrapesmodalContent
              // pageid={this.setState.id}
              headerid={this.state.id}
              section={this.state.section}
              isOpen={this.state.isOpen}
              onClose={this.closeModals}
            />
          ) : (
            ""
          )}
          <button
            className="btn-custom-blue btn"
            // onClick={this.openModals}
            // onClick={() => this.openModals("headerpreview")}
            onClick={(e) => this.viewfooterSite()}
            style={{ border:'1px solid #664FC8' }}
          >
            Preview
          </button>
        </li>
      </ul>
    );
  }
}

function mapStateToProps(state) {
  // let initVals = {};
  return {
    session: state.session,
    // initialValues: initVals,
    headerFooter:state.headerFooter,
  };
}



export default connect(mapStateToProps)(FooterMenuList);

